module.exports = __webpack_public_path__ + "img/woman.94db2f7f.png";